export default __webpack_public_path__ + "static/media/pear.0fd61049.ogg";